import { Injectable, Inject } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { filter, map, flatMap } from 'rxjs/operators';
import { ApiEndPoints } from 'src/app/api-end-points';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient, private _apiEndPoints: ApiEndPoints) {
    Inject(ApiEndPoints)
  }

  getPosition(): Promise<any>
  {
    //getCurrentPosition
    return new Promise((resolve, reject) => {
      navigator.geolocation.watchPosition(resp => {
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
    });
  }

  public getEkycBasicInfo(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['getEkycBasicInfo'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }

  public validateTokenDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['validateEkycAadhaarToken'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }
}